export default {
  setErrors(state, payload) {
    state.errors = payload;
  },
};
